<scope-deliverables-row-header
  *ngIf="!config?.isIndependent && !config?.isTimeline"
  [level]="level"
  [config]="config" />

<div
  cdkDrag
  *ngFor="let deliverable of deliverables; trackBy: trackById"
  [cdkDragData]="deliverable"
  [cdkDragDisabled]="scopeElementsService.disableDragging"
  (cdkDragStarted)="scopeElementsService.deliverableDragging = true"
  (cdkDragEnded)="scopeElementsService.deliverableDragging = false; scopeElementsService.dragTargetId = null">
  <mat-icon class="material-symbols-rounded drag-indicator">drag_indicator</mat-icon>
  <scope-deliverables-row
    class="tr scope-row flex-col"
    [class.scope-row__outlined]="config?.isIndependent"
    [config]="config"
    [deliverable]="deliverable"
    [deliverableMenuOptions]="deliverableMenuOptions"
    [componentMenuOptions]="componentMenuOptions"
    [feeMenuOptions]="feeMenuOptions"
    [level]="level"
    [cdnConfig]="cdnConfig"
    (onExpandDeliverable)="expandDeliverable(config?.scopeVersion.identity.id, deliverable.id)"
    (onUpdateDeliverable)="onUpdateDeliverable.emit($event)"
    (onUpdateComponent)="onUpdateComponent.emit($event)"
    (onUpdateFeeItem)="onUpdateFeeItem.emit($event)"
    (onUpdateRole)="onUpdateRole.emit($event)"
    (onUpdateDeliverableTpc)="onUpdateDeliverableTpc.emit($event)"
    (onUpdateComponentTpc)="onUpdateComponentTpc.emit($event)"
    (onUpdateDeliverableSectionTpc)="onUpdateDeliverableSectionTpc.emit($event)"
    (onReorderDeliverableTpcs)="onReorderDeliverableTpcs.emit($event)"
    (onReorderComponentTpcs)="onReorderComponentTpcs.emit($event)"
    (onReorderDeliverableSectionTpcs)="onReorderDeliverableSectionTpcs.emit($event)"
    (onAcceptDeliverable)="onAcceptDeliverable.emit($event)"
    (onRejectDeliverable)="onRejectDeliverable.emit($event)"
    (onMoveComponent)="onMoveComponent.emit($event)"
    (onMoveComponentOutsideDeliverable)="onMoveComponentOutsideDeliverable.emit($event)"
    (onOverrideComponentQuantity)="onOverrideComponentQuantity.emit($event)"
    (onOverrideRateCardRoleHours)="onOverrideRateCardRoleHours.emit($event)" />
</div>

<div
  class="text-for-empty"
  *ngIf="!section"
  [hidden]="deliverables?.length > 0">
  <p class="text">Drag &amp; Drop {{ 'deliverable.p' | lang }}</p>
  <p class="undertext">between sections or from this default section</p>
</div>

<div
  class="text-for-empty"
  *ngIf="section"
  [hidden]="
    !(scopeTabService.sectionSelectedStates[section.id] || section.id == scopeElementsService.dragTargetId) ||
    section.deliverables.length > 0
  ">
  <p class="text">Drag &amp; Drop {{ 'deliverable.p' | lang }}</p>
  <p class="undertext">between sections or from the unsectioned {{ 'deliverable.p' | lang }} below</p>
</div>
